module.exports = __webpack_public_path__ + "static/media/CX.5411670e.svg";